import ArrayData from '../../Arrays';

const productCategories = [
  { id: "BeautyPersonalCare", category: "Beauty & Personal Care" },
  { id: "FashionAccessories", category: "Fashion Accessories" },
  { id: "Footwear", category: "Footwear" },
  { id: "Jewelleries", category: "Jewelleries" },
  { id: "KidsProducts", category: "Kids Products" },
  { id: "MenBottomwear", category: "Men Clothing - Bottomwear" },
  { id: "MenInnerwearSleepwear", category: "Men Clothing - Innerwear & Sleepwear" },
  { id: "MenTopwear", category: "Men Clothing - Topwear" },
  { id: "UnisexProducts", category: "Unisex Products" },
  { id: "WomenBottomwear", category: "Women Clothing - Bottomwear" },
  { id: "WomenLingerieSleepwear", category: "Women Clothing - lingerie & Sleepwear" },
  { id: "WomenTopwear", category: "Women Clothing - Topwear" },
  { id: "WomenWesternwear", category: "Women Clothing - Westernwear" },
];

const categoryToProductsMap = {
    "Men Clothing - Topwear": ArrayData.MenTopwear,
    "Men Clothing - Bottomwear": ArrayData.MenBottomwear,
    "Men Clothing - Innerwear & Sleepwear": ArrayData.MenInnerwearAndSleepwear,
    "Women Clothing - Topwear": ArrayData.WomenTopwear,
    "Women Clothing - Bottomwear": ArrayData.WomenBottomwear,
    "Women Clothing - Westernwear": ArrayData.WomenWesternwear,
    "Women Clothing - lingerie & Sleepwear": ArrayData.WomenLingerieAndSleepwear,
    Footwear: ArrayData.Footwear,
    "Beauty & Personal Care": ArrayData.BeautyAndPersonalCare,
    "Jewelleries": ArrayData.Jewelleries,
    "Fashion Accessories": ArrayData.Accessories,
    "Unisex Products": ArrayData.UnisexProducts,
    "Kids Products": ArrayData.KidsProducts,
};

export {
    productCategories,
    categoryToProductsMap,
}
